// src/pages/profile/Profile.js
import React, { useState, useContext, useRef } from "react";
import { useForm } from "react-hook-form";
import FloatingInput from "../../../components/input/FloatingInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { ThemeContext } from "../../../context/ThemeContext";
import { useModal } from "../../../context/ModalContext";
import api from "../../../api/axios";
import { useTranslation } from "react-i18next";

export default function ResendWelcomeEmailModel({ user, handleUpdateToaster }) {
  const { t: trans } = useTranslation();
  const theme = useContext(ThemeContext);
  const { closeModal } = useModal();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const emailValidRef = useRef(true);

  // -------------- Validation Schema ----------------
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(trans("Invalid email address"))
      .required(trans("Email is required")),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });


  // -------------- Submit Handler ----------------
  const handleSendEmail = async (formData) => {
    if (!emailValidRef.current) return;

    try {
      setIsSubmitting(true);

      const response = await api.post("/users/send-profile-welcome-email", {
        email: formData.email,
        maincompanyid: theme.id,
        id: user?.id,
      });

      if (response.data?.status === "success") {
        handleUpdateToaster({ message: "Welcome email sent successfully!", visible: true, type: 'success' });
        closeModal();
      } else {
        handleUpdateToaster({ message: response.data?.message || "Failed to send welcome email", visible: true, type: 'error' });
      }
    } catch (err) {
      handleUpdateToaster({ message: "Server error: Unable to send email", visible: true, type: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="user-p1">
      <div className="user-form1">
        <div style={{ padding: "30px" }}>
          <form>
            {/* Email Field */}
            <div className="form-group" style={{ marginBottom: "20px" }}>
              <div class="floating-input-wrapper">
                <FloatingInput
                  label="Email"
                  {...register("email")}
                />
              </div>
              {errors.email && (
                <p className="field-error" >
                  {errors.email.message}
                </p>
              )}
            </div>

            {/* Buttons */}
            <div className="full-width-container-btn">
              <button
                type="button"
                className="submit-btn btn-bg w-120 discard-btn"
                onClick={closeModal}
              >
                {trans("Discard")}
              </button>

              <button
                type="button"
                className="submit-btn btn-bg w-190"
                style={{ backgroundColor: theme.primary_color }}
                disabled={isSubmitting}
                onClick={handleSubmit(handleSendEmail)}
              >
                {isSubmitting ? trans("Sending...") : trans("Send Email")}
              </button>

            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
